import React, { useState } from "react";
import { flushSync } from "react-dom";
import { Link, NavLink } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import SideMenu from "./SideMenu";
import { ListIcon } from "@phosphor-icons/react";

export default function NavBar() {
  let [listIsOpen, setListIsOpen] = useState(false);

  let navData = [
    {
      name: "محصولات",
      whereTo: "products/all",
      title: "محصولات",
      isDisabled: false,
      classPlus: "",
      sub: [{ name: "کیت‌های رپید", whereTo: "rapid_test_kits" }],
    },
    // {
    //   name: "وبلاگ",
    //   whereTo: "blog",
    //   title: "وبلاگ آزمایاران",
    //   isDisabled: false,
    //   classPlus: "",
    // },
    {
      name: "همکاری",
      whereTo: "",
      title: "همکاری با ما",
      isDisabled: true,
      classPlus: "",
    },
  ];

  let navLinks = navData.map((item, i) => {
    return (
      <div
        key={`nav-${i}`}
        className={`${item.sub ? "group" : ""} relative max-h-20 overflow-hidden`}
      >
        <NavLink
          viewTransition
          key={i}
          to={!item.isDisabled ? item.whereTo : null}
          title={item.title}
          className={({ isActive }) =>
            `relative hidden h-fll w-40 h-20 flex-col justify-center transition duration-300 ease-in-out hover:text-green-900 hover:bg-green-900/10 hover:bg-opacity-20 hover:font-semibold lg:flex ${
              isActive && !item.isDisabled
                ? " bg-lime-950/5 font-semibold hover:bg-opacity-30"
                : " "
            } ${item.classPlus} `
          }
          onClick={(e) => {
            if (item.isDisabled) {
              e.preventDefault();
            } else {
              // window.scrollTo(0, 0);
            }
          }}
        >
          {item.name}
          {item.isDisabled && (
            <div className="absolute right-[30%] top-[60%] rounded-sm bg-red-700 p-px px-0.5 text-xs text-white ">
              به زودی
            </div>
          )}
        </NavLink>
        <ul className="hidden group-hover:block  fixed -bottom-16 w-40 z-20 bg-white/80 backdrop-blur-md rounded-b-lg">
          {item?.sub?.map((s, i) => (
            <li
              key={`to-${s}-${i}`}
              className=" hover:text-green-900 hover:rounded-lg hover:bg-green-900/10 p-5 w-full h-fit transition ease-in-out "
            >
              <Link to={`/products/${s.whereTo}`} className="w-full h-full ">
                {s.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  });

  return (
    <nav
      className={`sticky  top-0 z-20 flex flex-col items-center justify-start bg-olive-50/80 backdrop-blur  px-2 text-md drop-shadow-sm md:w-full lg:flex-row lg:justify-between lg:h-20  lg:px-8 lg:pl-2  lg:text-center ${
        listIsOpen && "h-screen"
      }`}
      id="top"
    >
      <Link to={"./"} title="صفحه اصلی" className="hidden md:block">
        <motion.img
          initial={{ y: -20 }}
          animate={{ y: 0 }}
          src="/imgs/logo.svg"
          alt="لوگوتایپ آزمایاران"
          className="max-h-20"
        />
      </Link>
      <div className="flex w-screen flex-row-reverse items-center justify-between px-2 py-1 lg:hidden border-b">
        <Link to={"./"} title="صفحه اصلی">
          <img src="/imgs/logoType.svg" alt="لوگوتایپ آزمایاران" className="" />
        </Link>

        <div
          className=""
          onClick={() => {
            if (document.startViewTransition) {
              document.startViewTransition(() => {
                flushSync(() => {
                  setListIsOpen(!listIsOpen);
                });
              });
            } else {
              setListIsOpen(!listIsOpen);
            }
          }}
        >
          <ListIcon size={28} />
        </div>
      </div>

      <AnimatePresence mode="wait">
        {listIsOpen && <SideMenu setListIsOpen={setListIsOpen} />}
      </AnimatePresence>

      <div className="flex items-center  pl-10 h-full">{navLinks}</div>
    </nav>
  );
}
